import { createVanIconComponent } from "./van"

const QuestionOutlined = createVanIconComponent("question-o")
export default QuestionOutlined
